import { Outlet } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { SmoothScroll } from "./SmoothScroll";
import { WhatsAppButton } from "./WhatsAppButton";

export const Layout = () => (
  <>
    <SmoothScroll />
    <Nav />
    <main>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppButton />
  </>
);
